import { render } from "./OrcamentoView.vue?vue&type=template&id=03c0f72e"
import script from "./OrcamentoView.vue?vue&type=script&lang=js"
export * from "./OrcamentoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__